import '.a{display:flex;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.b5{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ay{max-width:77.5rem;}.ssr-plugin'
import '.fh{justify-content:stretch;}.ssr-plugin'
import '.bj{position:sticky;}.ssr-plugin'
import '.bk{top:0px;}.ssr-plugin'
import '.bl{z-index:10;}.ssr-plugin'
import '.fq{padding-block:1rem;}.ssr-plugin'
import '.fr{height:3rem;}.ssr-plugin'
import '.ba{justify-content:space-between;}.ssr-plugin'
import '.bc{flex-wrap:wrap;}.ssr-plugin'
import '.ft{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ei{margin-top:2rem;}.ssr-plugin'
import '.hl{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a a8 ab b e2"
      >
        <div className="b5 a r ab b"
        >
          <div className="ay a b fh bj bk bl"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fq fr a ba r bc"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ft a b a8 ei hl ay"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
